import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { useLoader } from './useLoader';
import { useErrorMessage } from './useErrorMessage';

const protectedFetch = axios.create();

// protectedFetch.interceptors.request.use((config) => config);

export const useFetch = () => {
    const { showLoader, hideLoader } = useLoader();
    const { setErrorMessage } = useErrorMessage();
    const protectedFetch = <REQUEST = unknown, RESPONSE = unknown>(options: AxiosRequestConfig<REQUEST>): Promise<AxiosResponse<RESPONSE>> => {
        showLoader();

        return new Promise<AxiosResponse<RESPONSE>>((resolve, reject) => {
            axios(options)
                .then((response: AxiosResponse<RESPONSE>) => resolve(response))
                .catch((e) => {
                    console.error(e);
                    const message = e.response.data.message || e.response.data.error_message;

                    setErrorMessage(message);
                    reject(e);
                });
        })
            .finally(() => hideLoader());
    };

    return {
        fetch: axios,
        protectedFetch,
    };
};
